<script>
    export let value = "";
    export let name = undefined;
    export let label = undefined;
    export let placeholder = undefined;
    export let disabled = false;
    export let required = false;
    export let autocomplete = undefined;
</script>

<div class="root vstack">
    {#if label}
        <label class="label" for="password">{label}</label>
    {/if}
    <input
        class="input"
        type="text"
        bind:value
        {name}
        {placeholder}
        {disabled}
        {required}
        {autocomplete}
        on:change
        on:input
        on:keyup
        on:keydown
        on:keypress
    />
</div>

<style>
    .label {
        font-weight: bold;
        padding-bottom: 5px;
    }

    .input {
        outline: none;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        padding: 7px 10px;
        margin: 0;
        color: var(--fg-color);
        background: transparent;
        font-size: 16px;
        font-weight: 600;
        font-family: inherit;
        border-radius: 5px;
        /* border: solid 2px var(--darker-bg-color); */
        border: solid 2px var(--fg-color);
        transition: border-color 0.15s;
    }
    .input:focus,
    .input:hover {
        border-color: var(--fg-color);
        color: var(--hover-fg-color);
        background-color: var(--hover-bg-color);
    }
    .input:invalid {
        box-shadow: none;
        /* border-color: #C00; */
    }
    .input::placeholder {
        color: var(--placeholder-color);
    }
    .input:disabled {
        color: var(--disabled-fg-color);
        background-color: var(--disabled-bg-color);
    }
    .input:disabled::placeholder {
        color: var(--dark-color);
    }
</style>
